import React from "react";
import { Hammer, Wrench } from "lucide-react";

export const Counters = ({ items }) => {
  const nInst = items.filter((i) => i.tipo === "installazione").length;
  const nInt = items.length - nInst;
  return (
    <>
      <span className="inline-flex items-center gap-1"><Hammer className="w-3.5 h-3.5" style={{ color: "#1B5E20" }} /> {nInst} installazion{nInst === 1 ? "e" : "i"}</span>
      <span className="inline-flex items-center gap-1"><Wrench className="w-3.5 h-3.5" style={{ color: "#E65100" }} /> {nInt} intervent{nInt === 1 ? "o" : "i"}</span>
    </>
  );
};
